import React from 'react';
import { Clock, Sparkles, Users } from 'lucide-react';
import type { ReferralStats as ReferralStatsData } from '../../types/referral';
interface ReferralStatsProps {
  stats: ReferralStatsData;
  loading?: boolean;
}
export function ReferralStats({
  stats,
  loading = false
}: ReferralStatsProps) {
  const items = [{
    label: 'Total friends invited',
    value: stats.totalInvited,
    Icon: Users
  }, {
    label: 'Earned credits',
    value: stats.earnedCredits,
    Icon: Sparkles
  }, {
    label: 'Pending invites',
    value: stats.pendingInvites,
    Icon: Clock
  }];
  return <dl className="grid grid-cols-1 gap-4 md:grid-cols-3" data-id="element-1772" data-mp="2jzcj79djbjkk">
      {items.map(({
      label,
      value,
      Icon
    }) => <div key={label} className="rounded-2xl border border-gray-800 bg-[#0A0A0A] p-5" data-id="element-1773" data-mp="2fvejawgdy4qg">
          <div className="mb-4 flex items-center justify-between gap-3" data-id="element-1774" data-mp="3vfswox5j3q4s">
            <dt className="font-mono text-[10px] uppercase tracking-[0.18em] text-gray-500" data-id="element-1775" data-mp="3rbl76xr8y65i">
              {label}
            </dt>
            <Icon size={16} className="text-gray-600" aria-hidden="true" data-id="element-1776" data-mp="irtz3v2k8zr4" />
          </div>
          <dd className="text-3xl font-black leading-none text-white" data-id="element-1777" data-mp="nqornoqby2of">
            {loading ? <span className="inline-block h-7 w-10 animate-pulse rounded bg-gray-800" data-id="element-1778" data-mp="ro34dqd7ysl6" /> : value}
          </dd>
        </div>)}
    </dl>;
}